import * as React from "react"
import { cn } from "@/lib/utils"

type Props = {
  src: string
  alt: string
  size?: "sm" | "md" | "lg"
  className?: string
}

const SIZES: Record<NonNullable<Props["size"]>, string> = {
  sm: "size-8",
  md: "size-12",
  lg: "size-16",
}

export function IntegrationLogo({ src, alt, size = "md", className }: Props) {
  const [errored, setErrored] = React.useState(false)
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-md bg-white border border-neutral-200 overflow-hidden shrink-0",
        SIZES[size],
        className,
      )}
    >
      {errored ? (
        <span className="text-xs font-semibold text-neutral-500 uppercase">
          {alt.slice(0, 2)}
        </span>
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setErrored(true)}
          className="size-full object-contain p-1.5"
        />
      )}
    </div>
  )
}
